// Force header logo to always use the full-res src (not srcset).
// Applied only on policy / static pages (body class is exactly "t-" — empty template).
// On those pages the browser picks ?width=200 from srcset which serves a stacked
// "THE / RISING" design. The full src serves the horizontal wordmark, matching
// what collection/product pages show. Leaves all other page types untouched.
function risingFixLogoSrcset() {
  // body.t- = empty template (all Shopify policy pages, 404, password, etc.)
  // body.t-page = custom .page templates (Delivery, Find Stockists, etc.)
  if (!document.body.classList.contains('t-') &&
      !document.body.classList.contains('t-page')) return;
  document.querySelectorAll('header img.logo').forEach(function(img) {
    img.removeAttribute('srcset');
    img.removeAttribute('sizes');
  });
}
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', risingFixLogoSrcset);
} else {
  risingFixLogoSrcset();
}

// Replace <br> tags inside trust bar spans with a space (mobile single-line fix)
// Also fix BRs inside science_daily_stress p — run multiple times to catch late-loading DOM
function risingFixBRs() {
  document.querySelectorAll('[class*="gs-features-bar-"] span br').forEach(function (br) {
    br.parentNode.replaceChild(document.createTextNode(' '), br);
  });
  document.querySelectorAll('#shopify-section-template--20806364168329__science_daily_stress p br').forEach(function (br) {
    br.parentNode.replaceChild(document.createTextNode(' '), br);
  });
}
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', risingFixBRs);
} else {
  risingFixBRs();
}
setTimeout(risingFixBRs, 100);
setTimeout(risingFixBRs, 500);
setTimeout(risingFixBRs, 1500);

// PDP title row — move Judge.me preview badge into the title section so it sits next to the product title.
// DESKTOP ONLY (>= 778px). On mobile, the badge stays as a sibling above the title (handled by rising-pdp-mobile.css).
function risingMoveJdgmIntoTitle() {
  var isDesktop = window.matchMedia('(min-width: 778px)').matches;
  var title = document.querySelector('product-content > section.title');
  if (!title) return;
  var jdgmEl = document.querySelector('product-content section.itsapp .jdgm-prev-badge');
  if (!jdgmEl) return;
  var jdgmHost = jdgmEl.closest('section.itsapp');
  if (!jdgmHost) return;

  // Both desktop and mobile: move badge BEFORE section.title (above the title)
  if (title.contains(jdgmHost)) {
    title.parentNode.insertBefore(jdgmHost, title);
  } else if (jdgmHost.parentNode !== title.parentNode || title.previousElementSibling !== jdgmHost) {
    title.parentNode.insertBefore(jdgmHost, title);
  }
}
// Re-run on resize to handle device rotation / responsive testing
window.addEventListener('resize', function() {
  clearTimeout(window._risingResizeT);
  window._risingResizeT = setTimeout(risingMoveJdgmIntoTitle, 150);
});
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', risingMoveJdgmIntoTitle);
} else {
  risingMoveJdgmIntoTitle();
}
setTimeout(risingMoveJdgmIntoTitle, 200);
setTimeout(risingMoveJdgmIntoTitle, 800);
setTimeout(risingMoveJdgmIntoTitle, 2000);

// Wire "WRITE A REVIEW" button in reviews_header to Judge.me review form (open modal without scrolling)
document.addEventListener('click', function (e) {
  var a = e.target.closest('a[href="#shopify-product-reviews"], a[href*="shopify-product-reviews"]');
  if (!a) return;
  e.preventDefault();
  e.stopPropagation();
  var trigger = document.querySelector('[data-testid="write-review-button"], .jdgm-write-rev-link, .jm-action-buttons__button');
  if (trigger) trigger.click();
  return false;
});

// ============================================================
// PDP Mobile: "Read more" toggle for product description — clamp to 3 lines
// ============================================================
function risingDescReadMore() {
  if (window.innerWidth > 777) return;
  var rte = document.querySelector('.product-page product-content .rte');
  if (!rte || rte.dataset.readMoreInit) return;
  // Description is inside a collapsible accordion — no read-more needed
  if (rte.closest('details')) return;
  rte.dataset.readMoreInit = '1';
  // Add clamp class
  rte.classList.add('rising-clamped');
  // Only proceed if content actually overflows
  if (rte.scrollHeight <= rte.clientHeight + 2) {
    rte.classList.remove('rising-clamped');
    return;
  }
  // Build button
  var btn = document.createElement('button');
  btn.className = 'rising-read-more-btn';
  btn.textContent = 'Read more';
  btn.addEventListener('click', function() {
    var clamped = rte.classList.toggle('rising-clamped');
    btn.textContent = clamped ? 'Read more' : 'Read less';
  });
  rte.parentNode.insertBefore(btn, rte.nextSibling);
}
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', risingDescReadMore);
} else {
  risingDescReadMore();
}
setTimeout(risingDescReadMore, 300);
setTimeout(risingDescReadMore, 1000);

// ============================================================
// Footer: MORE INFO expandable on mobile
// Hides the 2nd .f-col (DELIVERY/RETURN/CONTACT/PRIVACY/TERMS)
// Adds a "MORE INFO ↓" toggle as the last item of the 1st .f-col
// On click → reveals the hidden 5 items below
// ============================================================
function risingFooterMoreInfo() {
  if (window.innerWidth > 777) return; // mobile only
  var footer = document.querySelector('footer');
  if (!footer) return;
  if (footer.querySelector('[data-rising-more-info]')) return; // already initialized
  var fcols = footer.querySelectorAll('.f-col');
  if (fcols.length < 2) return;
  var firstUl = fcols[0].querySelector('ul');
  var secondCol = fcols[1];
  if (!firstUl || !secondCol) return;
  // Tag the 2nd column for CSS targeting
  secondCol.setAttribute('data-rising-more-info-target', '');
  // Build the toggle item
  var li = document.createElement('li');
  li.setAttribute('data-rising-more-info', '');
  li.style.cursor = 'pointer';
  li.style.listStyle = 'none';
  var btn = document.createElement('button');
  btn.type = 'button';
  btn.setAttribute('aria-expanded', 'false');
  btn.style.cssText = 'background:none!important;border:none!important;padding:0!important;margin:0!important;color:inherit;font:inherit;cursor:pointer;display:inline-flex;align-items:center;gap:12px;text-align:left;line-height:inherit;opacity:0.75;';
  btn.innerHTML = 'MORE INFO <span data-rising-more-info-arrow style="display:inline-flex;align-items:center;justify-content:center;transition:transform 0.3s ease;line-height:1;vertical-align:middle;color:inherit;"><svg width="8" height="14" viewBox="0 0 5 9" fill="none" xmlns="http://www.w3.org/2000/svg" style="display:block;"><path d="M2.25 0.25L2.25 8.25M2.25 8.25L0.25 6.53571M2.25 8.25L4.25 6.53571" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"/></svg></span>';
  li.appendChild(btn);
  firstUl.appendChild(li);
  // Toggle behaviour
  btn.addEventListener('click', function(e) {
    e.preventDefault();
    var isOpen = secondCol.classList.toggle('rising-more-info-open');
    btn.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    var arrow = btn.querySelector('[data-rising-more-info-arrow]');
    if (arrow) arrow.style.transform = isOpen ? 'rotate(180deg)' : 'rotate(0deg)';
  });
}
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', risingFooterMoreInfo);
} else {
  risingFooterMoreInfo();
}
window.addEventListener('resize', function() {
  clearTimeout(window._risingFooterT);
  window._risingFooterT = setTimeout(risingFooterMoreInfo, 200);
});

// PDP Thumbnails: handled entirely by CSS in theme.liquid inline <style> block.
// No JS needed — stylesheet !important beats slider-component's inline JS styles.
